import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { usePortalAuth } from "@/hooks/usePortalAuth";
import { useAuth } from "@/hooks/useAuth";
import { useTenant } from "@/contexts/TenantContext";

const NotFound = () => {
  const location = useLocation();
  const { portalUser } = usePortalAuth();
  const { userRole } = useAuth();
  const { isGreenvisionCharging } = useTenant();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  // Determine the correct home route based on user role
  let homeRoute = '/quickscan/flex-e';
  let homeText = 'Terug naar home';

  if (portalUser?.role === 'inspector') {
    homeRoute = '/inspector';
    homeText = 'Terug naar je dashboard';
  } else if (portalUser?.role === 'client') {
    homeRoute = '/client';
    homeText = 'Terug naar je dashboard';
  } else if (userRole === 'charging_user' && isGreenvisionCharging) {
    homeRoute = '/charging';
    homeText = 'Terug naar Charging Portal';
  } else if (userRole && ['admin', 'super_admin', 'crm_user'].includes(userRole)) {
    homeRoute = '/crm';
    homeText = 'Terug naar CRM';
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-muted-foreground mb-4">Pagina niet gevonden</p>
        <Link to={homeRoute} className="text-primary hover:underline">
          {homeText}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
